import isNil from "lodash.isnil";
import { logEvent, setUserId } from "scripts/utils/amplitude";
import { getGlobal } from "scripts/utils/global";
const UNVERIFIED = "UNVERIFIED";

const checkIsPostModeration = () => {
  const elem = document.querySelector("[data-post-moderation-book]");

  if (isNil(elem)) {
    return false;
  }

  return elem.dataset.postModerationBook === "True";
};

const sendModerateBookAnalyticEvent = (form, targetStatuses) => {
  return new Promise((fulfill, reject) => {
    if (!getGlobal("__ANALYTICS_ENABLE__")) {
      reject("Analytics not enabled");
    }

    const {
      uuid,
      analyticsModerationPhase,
      moderatorName,
      bookOwnerTrackingId
    } = form.dataset;
    const [metaStatus, fileStatus] = targetStatuses; // For correct logic Amplitude need send this amplitude event with
    // book owner user tracking id as Amplitude userId system properties

    setUserId(bookOwnerTrackingId);

    switch (analyticsModerationPhase) {
      case "first":
        {
          if (metaStatus !== UNVERIFIED && fileStatus !== UNVERIFIED) {
            logEvent("modStatusChange", {
              uuid,
              metastatus: metaStatus,
              filestatus: fileStatus,
              moderator: moderatorName
            });
          }

          break;
        }

      case "final":
        {
          logEvent("modFinalStatusChange", {
            uuid,
            metastatus: metaStatus,
            filestatus: fileStatus,
            postMod: checkIsPostModeration(),
            moderator: moderatorName
          });
          break;
        }

      default:
        // Add for detect logic failed
        reject("Not detect type of Moderation Phase");
    }

    const {
      user: {
        trackingId: moderatorTrackingId
      }
    } = getGlobal("app"); // Return moderator tracking id as Amplitude userId system properties

    setUserId(moderatorTrackingId);
    fulfill(form);
  });
};

export { sendModerateBookAnalyticEvent };